import AuthService from '@/features/auth/authService.js'
import { initChatStateListeners } from './chatState.js'

const CHAT_CONFIG = {
  serviceId: '6962843faf54bb42894fd902',
  projectId: '69628892af54bb42894fd904',
  adminUserId: 'admin-1',
}

let initialized = false
let initPromise = null

function initChatWidget() {
  initChatStateListeners()

  // déjà en cours d'initialisation
  if (initPromise) return initPromise

  // déjà initialisé
  if (initialized) return Promise.resolve()

  initPromise = new Promise((resolve, reject) => {
    const tryInit = () => {
      const user = AuthService.getUserData()

      if (!user) {
        // pas d'utilisateur connecté, on résout quand même
        initPromise = null
        resolve()
        return
      }

      if (!window.XenoTalk) {
        // widget pas encore chargé, on réessaie dans 100ms
        setTimeout(tryInit, 100)
        return
      }

      try {
        const adminName = user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Support Admin'
        window.XenoTalk.init({
          userId: CHAT_CONFIG.adminUserId,
          userName: adminName,
          primaryColor: '#ff7200', // Couleur principale (ex: Orange)
          activateSound: true, // Activer les effets sonores
          title: 'XenoTalk Support', // Titre du chat
        })
        window.XenoTalk.createUI()
        initChatStateListeners()
        initialized = true
        console.log('✅ Chat widget initialized with userId:', CHAT_CONFIG.adminUserId)
        resolve()
      } catch (error) {
        console.error('❌ Error initializing chat widget:', error)
        initPromise = null
        reject(error)
      }
    }

    tryInit()
  })

  return initPromise
}

// essayer d'initialiser dès le chargement du script
if (typeof window !== 'undefined') {
  // attendre que le DOM soit prêt et le widget chargé
  const earlyInit = () => {
    const user = AuthService.getUserData()
    if (user) {
      console.log('🚀 Early chat widget init - user already logged in')
      initChatWidget()
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', earlyInit)
  } else {
    // DOM déjà prêt
    setTimeout(earlyInit, 100)
  }
}

export { initChatWidget, CHAT_CONFIG }
